// SPDX-FileCopyrightText: 2024 Comcast
//
// SPDX-License-Identifier: LicenseRef-Comcast

export { createArrayComparerSelector } from './array-comparer-selector';
